@if (!pageLoadComplete()) {
  <is-wait-message [loadComplete]="pageLoadComplete()" [useBolt]="false" [waitMessage]="'Please wait while we process your request.'" [timeoutAmount]="0">
  </is-wait-message>
}

@if (formGroup && pageLoadComplete()) {
  <form [formGroup]="formGroup.group" class="manage-payment-form-container" (ngSubmit)="onSubmit()">
    <div class="bolt-container">
      <bolt-progress-bar appFocusOnInit arialabel="remove refund method progress value is 50%" class="progress-bar-container to-container" value="50"></bolt-progress-bar>
      <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Remove refund method</h1>
      @if (globalErrorDisplayable) {
        <bolt-notification type="error" aria-labelledby="global-error-message" [id]="'global-error-message'" class="bolt-space-bottom-xl to-container">
          Please check the information below and try again.
        </bolt-notification>
      }
      <section class="fluid-container">
        <app-payment-sub-header>
          Remove refund method
        </app-payment-sub-header>
        <app-are-you-sure-radio-buttons formGroupName="areYouSureFormGroup" [submitted]="submitted()" [displayMessage]="displayMessageForForm"></app-are-you-sure-radio-buttons>
      </section>
    </div>
    <bolt-button-bar>
      <bolt-button slot="cancel" id="cancel-button" aria-label="cancel" (click)="cancelRemoveRefundMethod()">Cancel</bolt-button>
      <bolt-button submit aria-label="submit" type="solid" slot="forward" id="submit-button">Submit</bolt-button>
    </bolt-button-bar>
  </form>
}